export default __webpack_public_path__ + "static/media/29.b7c986f3.jpg";